<template>
	<div>
		<image-preview v-if="imageUrl !== null" :image-url="imageUrl" :title="tooltipLabel" />
		<span v-else>-</span>
	</div>
</template>

<script>
import ImagePreview from '@/components/ImagePreview.vue';

export default {
	components: {
		ImagePreview,
	},
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		proofType: {
			type: String,
			default: 'proof_of_shipping',
		},
	},
	computed: {
		imageUrl() {
			let url = null;

			if (this.proofType === 'proof_of_shipping') {
				url = this.data.proof_of_shipping;
			} else if (this.proofType === 'proof_of_delivery') {
				url = this.data.proof_of_delivery;
			}

			return url;
		},
		tooltipLabel() {
			let label = '';

			if (this.proofType === 'proof_of_shipping') {
				label = 'Show PoS';
			} else if (this.proofType === 'proof_of_delivery') {
				label = 'Show PoD';
			}

			return label;
		},
	},
};
</script>
